import Parent from '../views/Parent.vue';

// import view master
import Province from '../views/master/Province.vue';
import District from '../views/master/District.vue';
import Subdistrict from '../views/master/Subdistrict.vue';
import Village from '../views/master/Village.vue';
import Postalcode from '../views/master/Postalcode.vue';

const masterRoute = {
  path: '/master',
  name: 'Master',
  meta: {
    title: 'BNI QRIS - Master',
    appBarTitle: 'Master',
  },
  component: Parent,
  children: [
    {
      path: '/master/province',
      meta: {
        title: 'BNI QRIS - Province',
        appBarTitle: 'Province',
      },
      component: Province,
    },
    {
      path: '/master/district',
      meta: {
        title: 'BNI QRIS - District',
        appBarTitle: 'District',
      },
      component: District,
    },
    {
      path: '/master/sub-district',
      meta: {
        title: 'BNI QRIS - Subdistrict',
        appBarTitle: 'Subdistrict',
      },
      component: Subdistrict,
    },
    {
      path: '/master/village',
      meta: {
        title: 'BNI QRIS - Village',
        appBarTitle: 'Village',
      },
      component: Village,
    },
    {
      path: '/master/postalcode',
      meta: {
        title: 'BNI QRIS - Postalcode',
        appBarTitle: 'Postalcode',
      },
      component: Postalcode,
    },
  ],
};
export default masterRoute;
